import {
    createContactProperty,
    getContactProperty,
    deleteContactProperty,
    updateContactProperty,
} from "../../api/contactProperty.js";
import { log2 } from "../../utils/log2";

const log = log2("ContactPropertyStore");
const contactProperty = {
    namespaced: true,
    state: {
        data: [],
    },
    mutations: {
        SET_CONTACT_PROPERTY: (state, payload) => {
            state.data = payload;
        },
        ADD_CONTACT_PROPERTY: (state, payload) => {
            state.data.push(payload);
        },
        UPDATE_CONTACT_PROPERTY: (state, payload) => {
            state.data = state.data.map((data) => {
                let _data = data;
                if (data._id == payload._id) _data = payload;
                return _data;
            });
        },
        DELETE_CONTACT_PROPERTY: (state, id) => {
            state.data = state.data.filter((data) => data._id !== id);
        },
    },
    actions: {
        getContactProperty({ commit }) {
            return getContactProperty().then((response) => {
                commit("SET_CONTACT_PROPERTY", response.data);
            });
        },
        createContactProperty({ commit, state }, data) {
            return createContactProperty(data).then((response) => {
                const finded = state.data.find((d) => d._id == response.data._id);
                if (finded) {
                    commit("UPDATE_CONTACT_PROPERTY", response.data);
                } else {
                    commit("ADD_CONTACT_PROPERTY", response.data);
                }
                return response.data;
            });
        },
        deleteContactProperty({ commit }, id) {
            return deleteContactProperty(id).then((response) => {
                commit("DELETE_CONTACT_PROPERTY", id);
            });
        },
        updateContactProperty({ commit }, { id, data }) {
            return updateContactProperty(id, data).then((response) => {
                commit("UPDATE_CONTACT_PROPERTY", response.data);
            });
        },
    },
};

export default contactProperty;
